import React, { useState } from "react";
import { withSnackbar } from "notistack";
import {
  Slider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Tooltip,
  IconButton,
  Popover,
  ListItemText,
} from "@mui/material";
import {
  Room as MarkersIcon,
  BorderOuter as BorderOuterIcon,
  ModeOfTravel as ModeOfTravelIcon,
  PeopleAltOutlined as PeopleAltOutlinedIcon,
  LocalShippingOutlined as LocalShippingOutlinedIcon,
  Route as RouteIcon,
  BookmarkBorderOutlined as BookmarkBorderOutlinedIcon,
  AssessmentOutlined as AssessmentOutlinedIcon,
  EditLocationAltOutlined as EditLocationAltOutlinedIcon,
  DonutLargeOutlined as DonutLargeOutlinedIcon,
  ShareLocationOutlined as ShareLocationOutlinedIcon,
  ModeEditOutlineOutlined as ModeEditOutlineOutlinedIcon,
  BorderInner as BorderInnerIcon,
  StoreOutlined as StoreOutlinedIcon,
  Person as PersonIcon,
  Layers as LayersIcon,
  RvHookup as RvHookupIcon,
} from "@mui/icons-material";

import { DEFAULTS, TRIP_STATUS } from "common/config";
import { MONTHS } from "common/config";
import { LABELS } from "common/lables";
import { COMMON_JS } from "common/scripts";
import ChkBox from "components/Custom/ChkBox";

const MapRightSideFilters = (props: any) => {
  const {
    getMonthSales,
    setShowTripDelivery,
    showInnerBoundry,
    setShowInnerBoundry,
    setDetails,
    showMarker,
    setShowMarker,
    showRoute,
    setShowRoute,
    setShowUser,
    showDrilldown,
    setPlottings,
    setShowDrilldown,
    setShowDealer,
    setShowLabels,
    showLabels,
    showDealers,
    setShowVehicles,
    showTerritory,
    setTrackedUsers,
    setShowTerritory,
    showCharts,
    setShowCharts,
    showVehicles,
    setShowRecords,
    setPolyEdits,
    polyEdits,
    showTripDelivery,
    mapTypes,
    anchorEl,
    handleClick,
    tripStatus,
    anchorElTrips,
    handlePopoverClose,
    onSelectTripStatus,
    setMapTypes,
    handleClose,
    selectedMapType,
    tripState,
    getTripStatus,
    setSelectedMapType,
    plottings,
    showUser,
  } = props;

  const [showSlider, setShowSlider] = useState<boolean>(false);

  console.log("tripState", tripState);
  return (
    <>
      {/* slider */}
      {showSlider && (
        <div
          className={
            showTripDelivery ? "monthSalesSliderData" : "monthSalesSlider"
          }
          style={{ zIndex: 9999, top: 5 }}
        >
          <Slider
            step={null}
            track={false}
            defaultValue={[0]}
            marks={MONTHS}
            onChangeCommitted={(event, newValue) => {
              getMonthSales(event, newValue);
            }}
          />
        </div>
      )}

      <div
        className={"mapFiltersDiv"}
        style={{
          position: "absolute",
          right:
            polyEdits || showTripDelivery || plottings || showUser
              ? window.innerWidth * 0.24
              : 12,
        }}
      >
        <List
          className="MapFilterList"
          style={{ paddingTop: " 0px", paddingBottom: "0px" }}
        >
          <Tooltip title={LABELS.MARKERS} placement="left" arrow={true}>
            <ListItem
              disablePadding
              onClick={() => {
                setShowMarker(!showMarker);
              }}
            >
              <ListItemButton>
                <ListItemIcon
                  className="listItemBtnMap"
                  style={{ marginTop: "0.3rem" }}
                >
                  <MarkersIcon
                    fontSize="medium"
                    className={showMarker ? "onDisplay" : ""}
                  />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>

          <Tooltip title={LABELS.LABELS} placement="left" arrow={true}>
            <ListItem
              disablePadding
              onClick={() => {
                setShowLabels(!showLabels);
              }}
            >
              <ListItemButton>
                <ListItemIcon className="listItemBtnMap">
                  <BookmarkBorderOutlinedIcon
                    fontSize="medium"
                    className={showLabels ? "onDisplay" : ""}
                  />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>

          <Tooltip title={LABELS.USERS} placement="left" arrow={true}>
            <ListItem
              disablePadding
              onClick={() => {
                setShowUser(true);
                setTrackedUsers(null);
                setPolyEdits(false);
                setShowTripDelivery(false);
                setPlottings(false);
              }}
            >
              <ListItemButton>
                <ListItemIcon className="listItemBtnMap">
                  <PeopleAltOutlinedIcon
                    fontSize="medium"
                    className={showUser ? "onDisplay" : ""}
                  />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>

          <Tooltip title={LABELS.VEHICLES} placement="left" arrow={true}>
            <ListItem
              disablePadding
              onClick={() => {
                setShowVehicles(!showVehicles);
                if (showVehicles) {
                  setShowMarker(false);
                } else {
                  setShowMarker(true);
                }
              }}
            >
              <ListItemButton>
                <ListItemIcon className="listItemBtnMap">
                  <LocalShippingOutlinedIcon
                    fontSize="medium"
                    className={showVehicles ? "onDisplay" : ""}
                  />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>

          <Tooltip title={LABELS.DEALERS} placement="left" arrow={true}>
            <ListItem
              disablePadding
              onClick={() => {
                setShowDealer(!showDealers);
              }}
            >
              <ListItemButton>
                <ListItemIcon className="listItemBtnMap">
                  <StoreOutlinedIcon
                    fontSize="medium"
                    className={showDealers ? "onDisplay" : ""}
                  />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>

          <Tooltip
            title={LABELS.OUTER_TERRITORIES}
            placement="left"
            arrow={true}
          >
            <ListItem
              disablePadding
              onClick={() => {
                setShowTerritory(!showTerritory);
              }}
            >
              <ListItemButton>
                <ListItemIcon className="listItemBtnMap">
                  <BorderOuterIcon
                    fontSize="medium"
                    className={showTerritory ? "onDisplay" : ""}
                  />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>

          {/* <Tooltip
            title={LABELS.OUTER_TERRITORIES}
            placement="left"
            arrow={true}
          >
            <ListItem
              disablePadding
              onClick={() => {
                setShowOuterBoundry(!showOuterBoundry);
              }}
            >
              <ListItemButton>
                <ListItemIcon className="listItemBtnMap">
                  <BorderOuterIcon
                    fontSize="medium"
                    className={showOuterBoundry ? "onDisplay" : ""}
                  />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip> */}

          <Tooltip
            title={LABELS.INNER_TERRITORIES}
            placement="left"
            arrow={true}
          >
            <ListItem
              disablePadding
              onClick={() => {
                setShowInnerBoundry(!showInnerBoundry);
              }}
            >
              <ListItemButton>
                <ListItemIcon className="listItemBtnMap">
                  <BorderInnerIcon
                    fontSize="medium"
                    className={showInnerBoundry ? "onDisplay" : ""}
                  />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>

          <Tooltip title={LABELS.ROUTES} placement="left" arrow={true}>
            <ListItem
              disablePadding
              onClick={() => {
                setShowRoute(!showRoute);
              }}
            >
              <ListItemButton>
                <ListItemIcon className="listItemBtnMap">
                  <RouteIcon
                    fontSize="medium"
                    className={showRoute ? "onDisplay" : ""}
                  />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>

          <Tooltip title={LABELS.TRIP_DELIVERY} placement="left" arrow={true}>
            <ListItem
              disablePadding
              onClick={() => {
                setShowTripDelivery(!showTripDelivery);
                setPolyEdits(false);
                setPlottings(false);
                setShowUser(false);
                setDetails(null);
              }}
            >
              <ListItemButton>
                <ListItemIcon className="listItemBtnMap">
                  <ModeOfTravelIcon
                    fontSize="medium"
                    className={showTripDelivery ? "onDisplay" : ""}
                  />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>
          <Tooltip title={LABELS.REPORTS} placement="left" arrow={true}>
            <ListItem
              disablePadding
              onClick={() => {
                setShowSlider(!showSlider);
                setShowRecords(false);
              }}
            >
              <ListItemButton>
                <ListItemIcon className="listItemBtnMap">
                  <AssessmentOutlinedIcon
                    fontSize="medium"
                    className={showSlider ? "onDisplay" : ""}
                  />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>

          <Tooltip title={LABELS.ANALYTICS} placement="left" arrow={true}>
            <ListItem
              disablePadding
              onClick={() => {
                setShowCharts(!showCharts);
              }}
            >
              <ListItemButton>
                <ListItemIcon className="listItemBtnMap">
                  <DonutLargeOutlinedIcon
                    fontSize="medium"
                    className={showCharts ? "onDisplay" : ""}
                  />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>

          <Tooltip title={LABELS.MAP_DRILLDOWN} placement="left" arrow={true}>
            <ListItem
              disablePadding
              onClick={() => {
                setShowDrilldown(!showDrilldown);
                setShowDealer(!showDealers);
                setShowLabels(!showLabels);
                setShowRoute(!showRoute);
                setShowTerritory(!showTerritory);
                setShowInnerBoundry(!showInnerBoundry);
              }}
            >
              <ListItemButton>
                <ListItemIcon className="listItemBtnMap">
                  <ShareLocationOutlinedIcon
                    fontSize="medium"
                    className={showDrilldown ? "onDisplay" : ""}
                  />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>

          <Tooltip title={LABELS.EDIT_TERRITORY} placement="left" arrow={true}>
            <ListItem
              disablePadding
              onClick={() => {
                setPolyEdits(!polyEdits);
                if (!polyEdits) {
                  COMMON_JS.drawPolygon();
                } else {
                  COMMON_JS.closeDrawZone();
                }

                setShowTripDelivery(false);
                setShowUser(false);
                setPlottings(false);
              }}
            >
              <ListItemButton>
                <ListItemIcon className="listItemBtnMap">
                  <EditLocationAltOutlinedIcon
                    fontSize="medium"
                    className={polyEdits ? "onDisplay" : ""}
                  />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>

          <Tooltip title={LABELS.EDIT} placement="left" arrow={true}>
            <ListItem
              disablePadding
              onClick={() => {
                // setShowCharts(!showCharts);
              }}
            >
              <ListItemButton>
                <ListItemIcon className="listItemBtnMap">
                  <ModeEditOutlineOutlinedIcon fontSize="medium" />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>
        </List>
      </div>
      <>
        <div
          className="mapTypeAndTripStatus"
          style={{
            right:
              showTripDelivery || polyEdits || showUser || plottings
                ? window.innerWidth * 0.24
                : 12,
          }}
        >
          <div className="tripStatusFilter">
            <IconButton onClick={getTripStatus} aria-label="Users" size="small">
              <RvHookupIcon
                className={tripState.length !== 0 ? "onDisplay" : ""}
              />
            </IconButton>
          </div>
          <div className="mapTypeFilter">
            <IconButton
              aria-label="Map Types"
              size="small"
              onClick={handleClick}
            >
              <LayersIcon />
            </IconButton>
          </div>
        </div>
        <Popover
          style={{ margin: "-12px", zIndex: 9999 }}
          open={mapTypes}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
        >
          <List dense className="mapTypes uiPopOver">
            {DEFAULTS.MAP_TYPES.map((m, i) => {
              return (
                <ListItem
                  key={"mtype-" + i}
                  disablePadding
                  onClick={() => {
                    setSelectedMapType(i);
                    setMapTypes(false);
                  }}
                  className={i === selectedMapType ? "active" : ""}
                >
                  <ListItemButton>
                    <ListItemText primary={m} className="listText" />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Popover>

        <Popover
          style={{ margin: "-12px", zIndex: 9999 }}
          open={tripStatus}
          anchorEl={anchorElTrips}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
        >
          <div style={{ marginLeft: "20px", opacity: 0.82 }}>
            {TRIP_STATUS.map((item, index) => (
              <tr key={"tstatus-" + item}>
                <td style={{ opacity: 0.82 }}>
                  <ChkBox
                    id={item}
                    text={item}
                    controlled={true}
                    checked={tripState.indexOf(item) > -1}
                    onChange={(e, f) => {
                      onSelectTripStatus(e, f);
                    }}
                  />
                </td>
              </tr>
            ))}
          </div>
        </Popover>
      </>
    </>
  );
};

export default withSnackbar(MapRightSideFilters);
